import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { UserService } from '../services/user.service';
import { AuthService } from '../services/auth.service';
import { ScreeningInvite } from '../models/screeningInvite';
import { ClientLocation, Client } from '../models/clientLocation';
import { ClientService } from '../services/client.service';
import { SearchPackage } from '../models/searchPackage';
import { ScreeningService } from '../services/screening.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-screening-invite',
  templateUrl: './screening-invite.component.html',
  styleUrls: ['./screening-invite.component.less']
})
export class ScreeningInviteComponent implements OnInit {
  clientId: number;
  // client : Client;
  screeningInvite: ScreeningInvite;
  locations: Array<ClientLocation>;
  packages : Array<SearchPackage>;
  selectedPackage : SearchPackage;
  constructor(public toast: ToastrService, public location: Router, public activatedRoute: ActivatedRoute, public scrn: ScreeningService, public auth: AuthService, public clientSrv: ClientService) {
    this.screeningInvite = new ScreeningInvite();
    this.screeningInvite.messageType = 1;
    this.auth.titleBarText = "Tennant Screening Invitation";
    this.auth.roleFetchComplete.subscribe((dta: any) => {
      console.log('roles fetched');
      // TODO : pass the status code so know if we should actually redirect(401).
      if (dta.status == 401) this.location.navigateByUrl('/auth');
      else if (dta.status == 500) this.toast.error(`error ${dta}`);
    });
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(
      (params: ParamMap) => {
        this.clientId = parseInt(params.get('client'), 10);
        this.screeningInvite.clientId = this.clientId;
        this.auth.postLoginRedirect = '/screenings/invite/' + this.clientId;
        if (!localStorage.getItem('STP-JWT')) {
          this.auth.hasRedirect = true;
          this.location.navigateByUrl('/auth')
        } else {
          this.auth.GetUsersRoles();
          this.clientSrv.GetClientLocations(this.clientId).subscribe((results: any) => {
            this.locations = results.map((v) => { return v; });
          });
         
          this.clientSrv.FetchClientSearchPackages(this.clientId).subscribe((results : any)=>{
            this.packages = results.map((v) => {
              v.searches = v.searches;
              return v;
            });
          });
        }
      });
  }

  createInvitation() {
    this.scrn.SaveInvitation(this.screeningInvite).subscribe(
      (scc: any)=>{
        // If this is a pay as you go customer then we need to send them to payment.
        if(scc.hasPaymentLink){
          // Lets make some payment happen!!!
          // TODO: send user to that link
          console.log(scc)
          window.location = scc.paymentUrl;

        }else{
          this.toast.success('Your invitation has been sent.', '', {timeOut:5000});
          this.location.navigateByUrl("/screenings/list/" + this.clientId);
        }
      },
      (error: any)=>{
        this.toast.error(`error saving invitation ${error}`)
      }
      )
   
    console.log(this.screeningInvite);
  }

  update(ev:any){
    console.log(ev);
    this.screeningInvite[ev.name] = ev.value;
  }

  setPackage(pkg : any){
    console.log(pkg);
    this.screeningInvite.searchPackageId = pkg.value.id;
  }

  setLocation(loc: any){
    console.log(loc);
    this.screeningInvite.clientLocationId = loc.value.id;
  }



}
